import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import frLocale from "@fullcalendar/core/locales/fr";

import { SCHEDULE_EVENT_COLORS } from "@/constants/variables";
import planningService from "@/services/planning";
import leaveRequestService from "@/services/leaveRequest";
import Utils from "@/mixins/Utils";

import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import cloneDeep from 'lodash/cloneDeep'
import { LEAVE_REQUEST_STATUSES } from "../../constants/variables";

export default {
  components: {
    FullCalendar,
  },
  data: () => ({
    calendarLocales: frLocale,
    calendarPlugins: [timeGridPlugin, dayGridPlugin, listPlugin],
    header: { center: "dayGridMonth,timeGridWeek,listWeek" },
    eventsColors: SCHEDULE_EVENT_COLORS,
    events: [],
    interventions: [],
    isMonthChange: false,
    currentMonth: String(moment().month() + 1),
    currentView: "timeGridWeek",
    isLoadedEvents: false,
    startCalendarTime: new Date(),
    endCalendarTime: null,
    endValidDate: null,
    errorPlanning: undefined,
  }),
  mixins: [Utils],
  computed: {
    ...mapGetters({
      spinnerPlanning: "isLoading",
      leaveRequestsTypes: "leaveRequestsTypes",
      leaveRequestsStatus: "leaveRequestsStatus",
      leaveRequestStatuses: "leaveRequestStatuses"
    }),
    ...mapGetters('modificationRequest', {
      modifications: 'modifications'
    }),
    userId() {
      return JSON.parse(localStorage.getItem("user")).pkAdv;
    }
  },
  setup() {

  },
  async created() {
    try{
   
      this.isLoadedEvents = true;

      if (!this.leaveRequestsTypes.length) {
        await this.fetchLeaveRequestType();
      }

      
      await this.fetchModifyReq();
      let leaveRequestRes;
      if (!this.leaveRequestStatuses.length) {
        try {
          await this.getLeaveRequestStatuses();
        } catch(error) {}
    
      }


       try {
        this.events = await this.getAllInterventions();
     
       }  catch(error) {
        this.errorPlanning = error;
       }
    
     
      this.interventions = cloneDeep(this.events);
     

      // if (process.env.NODE_ENV === 'development') {
        const startTime = moment().startOf("month").format("x");
        const endTime = moment().endOf("month").format("x");
        try{
          this.events = await this.getLeaveRequests(this.userId, startTime, endTime);
        
        } catch(error) {
          this.events= this.interventions;
          
        }
      
      let d = new Date()
      let day = d.getDate()
      let firstDateOfMonth = new Date(d.getFullYear(), d.getMonth()+1, 1);

      let firstDayofNextMonth = new Date(d.getFullYear(), d.getMonth()+2, 1);
      if (day > 20  && this.startCalendarTime.getFullYear() === d.getFullYear()) {
        this.endValidDate = moment(firstDayofNextMonth).format("YYYY-MM-DD")
        
      } else {
        this.endValidDate = moment(firstDateOfMonth).format("YYYY-MM-DD")
         
      }
      if(!this.events) {
        this.errorPlanning = this.$t('error-schedule')
      }
      this.isLoadedEvents = false;


    } catch(error) {

    }
  
  },
  methods: {
    ...mapActions("modificationRequest", {
      fetchModifyReq: "REFRESH"
    }),
    ...mapActions(['getLeaveRequestStatuses', 'fetchLeaveRequestType']),
    getAllInterventions() {
      const vue = this;
      const currentDate = moment().date();
      const startDate = moment()
        .startOf("month")
        .subtract(5, "month");
      const endDate =
        currentDate >= 20
          ? moment()
              .startOf("month")
              .add(2, "month")
          : moment()
              .startOf("month")
              .add(1, "month");

      const time = {
        startTime: startDate.format("x"),
        endTime: endDate.format("x"),
      };
      return planningService
        .getPlanning(time)
        .then((res) => {
          const distinctClientsList = [];
          if (res.success) {
            res.data.map((schedule, index) => {
              if (!distinctClientsList.includes(schedule.pkClient)) {
                const isUpdated = vue.modifications.find(
                  e => e.idMission === schedule.idMission
                )
                const formattedObject = {
                  ...schedule,
                  title: schedule.fullName,
                  color: schedule.advMissing ? schedule.colorStatusDisplayed+' !important' : isUpdated ? (isUpdated.isMandataire ? "#FF9933" : "#FC0582") : (schedule.isMandataire ? "#F4C430" : "#F18EC0"),
                  id: schedule.idMission
                };
                distinctClientsList.push(formattedObject);
                return;
              }
             
              distinctClientsList.push(vue.formatRowData(schedule));
            });

            return distinctClientsList;
          }
        })
        .catch((err) => {
          vue.callToaster(vue.$t("problem-arise"));
        });
    },
    async getLeaveRequests(pkAdv, startTime, endTime){
      const vue = this;
      const { data } = await leaveRequestService.getLeaveRequestsByMonth(pkAdv, startTime, endTime)
      if (data && data.length) {
        const convertedEvents = data.filter(leave => 
          leave.pkIxLeaveStatut === LEAVE_REQUEST_STATUSES.VALIDATED
          || leave.pkIxLeaveStatut === LEAVE_REQUEST_STATUSES.VALIDATED_PENDING_CANCELLATION
          || leave.pkIxLeaveStatut === LEAVE_REQUEST_STATUSES.WAIT_FOR_VALIDATION
        ).map((request, index) => {
          const formattedObject = {
            ...request,
            start: moment(request.startDate).startOf("day").valueOf(),
            end: moment(request.endDate).endOf("day").valueOf(),
            title: `${this.renderType(request.pkIxLeaveType)} - ${this.leaveRequestsStatus(request.pkIxLeaveStatut)}`,
            color: "#feccff",
            id: request.pkLeaveRequest,
          };
          return formattedObject;
        });
        return [...vue.interventions, ...convertedEvents]
      }
      return vue.interventions;
     
      
    },
    renderType(typeId) {
      const result = this.leaveRequestsTypes.find((item) => item.value === Number(typeId));
      if(result && result.text) {
        return result.text
      }
      return '';
    },
    formatRowData(row) {
      return {
        title: row.fullName,
        start: moment(row.start).format("YYYY-MM-DD HH:mm:ss"),
        end: moment(row.end).format("YYYY-MM-DD HH:mm:ss"),
        color: this.eventsColors[
          distinctClientsList.indexOf(row.pkClient) % this.eventsColors.length
        ],
        allDay: false,
        id: row.idMission,
        className: row.idMission
      };
    },
    eventSelected(info){
      if(info.event._def.extendedProps.idMission) {
        const selectedEvent = this.events.filter(event => event.idMission === info.event._def.extendedProps.idMission)
        this.$router.push({
          name: "employee-schedule-detail",
          query: selectedEvent.length > 0 ? selectedEvent[0] : undefined,
        });
      }
      if(info.event._def.extendedProps.pkLeaveRequest) {
        this.$router.push({
          name: "employee-leave-form",
          params: { type: 'edit', id: info.event._def.extendedProps.pkLeaveRequest},
        });
      }
    },
    updateEnableNextBtn() {
      let calendarEl = document.getElementById('calendar')
      calendarEl.querySelectorAll('.fc-next-button').forEach((button) => {
      this.checkEnableNextButton(button);
    })
    },
    async handleMonthChange(arg) {
      if (this.currentView !== arg.view.type) {
        this.currentView = arg.view.type;
        this.updateEnableNextBtn(arg);
      }
      let d = new Date()
      let day = d.getDate();
      let currentMonth = d.getMonth();
   
      if(  new Date(arg.view.currentStart).getDate()!==day && new Date(arg.view.currentStart).getMonth() ==currentMonth || new Date(arg.view.currentStart).getMonth() !==currentMonth  ) {
        this.startCalendarTime = arg.view.currentStart;
        this.endCalendarTime = arg.view.currentEnd;
        let calendarEl = document.getElementById('calendar')
      calendarEl.querySelectorAll('.fc-next-button').forEach((button) => {
        this.checkEnableNextButton(button);
      })
      }
    
      if (this.currentMonth !== moment(arg.view.currentStart).format("MM") && !this.isMonthChange) {
        this.startCalendarTime = arg.view.currentStart;
        this.endCalendarTime = arg.view.currentEnd;
        // if (process.env.NODE_ENV === 'development') {
          this.isMonthChange = true
          const startTime = moment(arg.view.currentStart).startOf("month").format("x");
          const endTime = moment(arg.view.currentStart).endOf("month").format("x");
          this.events = await this.getLeaveRequests(this.userId, startTime, endTime);
          let calendarApi = this.$refs.fullCalendar.getApi();
          calendarApi.gotoDate(moment(arg.view.currentStart).format("YYYY-MM-DD"));
          this.currentMonth = moment(arg.view.currentStart).format("MM");
          this.isMonthChange = false;
      }
    },
    onAfterCalendarRender() {
      let calendarEl = document.getElementById('calendar');
      if(calendarEl) {
        calendarEl.querySelectorAll('.fc-next-button').forEach((button) => {
          this.checkEnableNextButton(button);
        })
      }
      

    },
    
    checkEnableNextButton(button) {
      let d = new Date()
      let day = d.getDate()
      let currentMonth = d.getMonth();
      let calendarMonth =  this.startCalendarTime.getMonth();
      let lastDayOfMonth = new Date(d.getFullYear(), d.getMonth()+1, 0);
      let lastDayofNextMonth = new Date(d.getFullYear(), d.getMonth()+2, 0);
        
        if (day > 20  && this.startCalendarTime.getFullYear() === d.getFullYear()) {
          switch(this.currentView) {
            case 'dayGridMonth': {
              if (
                currentMonth &&
                currentMonth == calendarMonth - 1
              ) {
                this.onDisableBtn(button,'month')
              } else {
                
                this.onEnablebutton()

      
              }
              break;

            }
            case 'listWeek':
            case 'timeGridWeek': {
              if (
                currentMonth &&
                currentMonth == calendarMonth - 1 && this.startCalendarTime && this.endCalendarTime && (this.startCalendarTime.getDate()-1) >=  (this.endCalendarTime && this.endCalendarTime.getDate() -1) || this.endCalendarTime && (this.endCalendarTime.getDate() - 1) == lastDayofNextMonth.getDate() && calendarMonth == currentMonth +1 )
               {
                this.onDisableBtn(button,'month')

              } else {
                
                 this.onEnablebutton()
      
              }
             break;

           }
          }
           
          } else {
            if(this.startCalendarTime.getFullYear() === d.getFullYear()) {
              switch(this.currentView) {
                case 'dayGridMonth': {
                  if(calendarMonth >= currentMonth && this.startCalendarTime.getFullYear() === d.getFullYear() ) {
                   this.onDisableBtn(button,'month')
                  }
                  break;
 
                }
                case 'listWeek':
                case 'timeGridWeek': {
                
                 if(calendarMonth > currentMonth || this.startCalendarTime && this.endCalendarTime && this.startCalendarTime.getDate() >=  (this.endCalendarTime.getDate()-1) && calendarMonth >= currentMonth || this.endCalendarTime && (this.endCalendarTime.getDate()-1) == lastDayOfMonth.getDate() && calendarMonth == currentMonth) {
                   this.onDisableBtn(button, 'week')
                  }
                 break;
 
               }
              }
            }
           
        }
    },
    onDisableBtn(button, keyTime) {
      if(button && button.disabled!==undefined) {
        button.disabled = true;
        button.classList.add('display-tooltip-button');
        switch (keyTime) {
           case 'month': 
           button.setAttribute('aria-label', this.$t('disabled-calendar-next-button-message')); 
           break;
          case 'week': 
          button.setAttribute('aria-label', this.$t('disabled-calendar-next-button-week-message')); 
          break;
  
        }
      }
     
    },
    onEnablebutton(button) {
        if(button && button.disabled!==undefined) {
          button.disabled = false;
          button.classList.remove('display-tooltip-button')
          button.setAttribute('aria-label', ``)
        }      

    }

  },
};
